import {create} from "zustand";
import {IWorkspaceMembers} from "../models/interfaces/workspaceMembers.interface.ts";
import {fetchWorkspaceMember, fetchWorkspaceMembers} from "../services/workspaceService.ts";
import {transformWorkspaceMembersDtoToWorkspaceMembers} from "../utils/transformers/workspace.transformer.ts";
import useUserStore from "./useUserStore.ts";
import {IWorkspaceMemberDto} from "../models/interfaces/dtos/workspaceMembers.dto.interface.ts";
import {IWorkspaceMember} from "../models/interfaces/workspaceMember.interface.ts";

interface IWorkspaceState {
  members: IWorkspaceMembers;
  getMember: (memberId: string) => Promise<IWorkspaceMember>
  getWorkspaceMembers: () => Promise<void>;
  addWorkspaceMember: (memberId: string) => Promise<void>;
}

const useWorkspaceStore = create<IWorkspaceState>((set, get) => ({
  members: {} as IWorkspaceMembers,
  getMember: async (memberId: string) => {
    const members: IWorkspaceMembers = get().members;
    if (!members[memberId]) {
      if (Object.keys(members).length === 0) {
        await get().getWorkspaceMembers();
      } else {
        await get().addWorkspaceMember(memberId);
      }
    }
    return members[memberId];
  },
  getWorkspaceMembers: async () => {
    try {
      const userWorkspaceId: string = useUserStore.getState().user!.workspaceId;
      const membersDto: IWorkspaceMemberDto[] = await fetchWorkspaceMembers(userWorkspaceId);
      const members: IWorkspaceMembers = transformWorkspaceMembersDtoToWorkspaceMembers(membersDto);
      set({members});
    } catch (error) {
      console.error("Error fetching workspace members:", error);
      throw error;
    }
  },
  addWorkspaceMember: async (memberId: string) => {
    try {
      const memberDto: IWorkspaceMemberDto[] = await fetchWorkspaceMember(memberId);
      const member: IWorkspaceMember = {
        userId: memberDto[0]._id,
        firstName: memberDto[0].firstName,
        lastName: memberDto[0].lastName,
        imageSasLink: memberDto[0].imageSasLink,
      };
      set((state) => ({
        members: {
          ...state.members,
          [member.userId]: member,
        },
      }));
    } catch (error) {
      console.error("Error adding workspace member:", error);
      throw error;
    }
  },
}));

export default useWorkspaceStore;